module.exports = "././img/dlgrma_elements.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/dlgrma_elements.svg
// module id = 816
// module chunks = 0